import * as React from 'react';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { FormattedMessage } from '@liveauctioneers/hammer-ui-core/intl';
import isEqual from 'react-fast-compare';
import styled from 'styled-components';

type Props = {
    body: React.ReactNode;
    className?: string;
    header: React.ReactNode;
    /** Add walkthrough DOM node */
    walkthroughStep?: string;
};

const DescriptionSection = ({ body, className, header, walkthroughStep }: Props) => {
    return (
        <StyledDescriptionSection className={className}>
            <StyledTitle as="h5">{typeof header === 'string' ? <FormattedMessage id={header} /> : header}</StyledTitle>
            <StyledBody>{body}</StyledBody>
            {walkthroughStep && <WalkthroughSpan data-walkthrough-step={walkthroughStep} />}
        </StyledDescriptionSection>
    );
};

export default React.memo(DescriptionSection, isEqual);

const StyledDescriptionSection = styled.div`
    padding: 0;
    margin: 0 0 32px;

    && {
        &:last-child {
            margin-bottom: 0;
        }
    }

    @media print {
        margin: 0 auto;
    }
`;

const StyledTitle = styled(BodyPrimary)`
    color: ${({ theme }) => theme.colors.grey100};
    margin: 0 0 8px;
`;

const StyledBody = styled(BodyPrimary)`
    margin: 0;
    white-space: pre-wrap;
    position: relative;

    * {
        max-width: 100% !important;
    }

    && {
        a {
            color: ${({ theme }) => theme.colors.blue100};

            &:hover {
                color: ${({ theme }) => theme.colors.blue200};
                text-decoration: none;
            }
        }
    }

    @media print {
        margin: 0.5em 0 !important;
        white-space: unset;
    }
`;

const WalkthroughSpan = styled.span`
    position: absolute;
    left: 16px;
    width: 0;
`;
